var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-header-card',{attrs:{"header":_vm.card_header,"rows":_vm.card_rows},scopedSlots:_vm._u([{key:"managedList",fn:function(){return [_c('a',{staticClass:"btn-link",attrs:{"href":`#/managed-lists/${_vm.managedList.id}`}},[_vm._v("\n      "+_vm._s(_vm.managedList.description)+"\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }